import { Component, inject } from '@angular/core';
import { GasOilAndLubricantService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  GasOilAndLubricantCreateDto,
  GasOilAndLubricantDto,
  GasOilAndLubricantExcelDownloadDto,
  GasOilAndLubricantUpdateDto,
} from '../proxy/general/dtos/gas-oil-and-lubricant';
import { GASOILANDLUBRICANT_CONFIG, GASOILANDLUBRICANT_FIELDS } from './gas-oil-and-lubricant.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-gas-oil-and-lubricant',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, GasOilAndLubricantService, ConfirmationService],
  templateUrl: './gas-oil-and-lubricant.html',
  styleUrl: './gas-oil-and-lubricant.scss',
})
export class GasOilAndLubricant extends BaseHierarchicalCrudComponent<
  GasOilAndLubricantDto,
  GasOilAndLubricantCreateDto,
  GasOilAndLubricantUpdateDto,
  GasOilAndLubricantExcelDownloadDto
> {
  service = inject(GasOilAndLubricantService);
  config = GASOILANDLUBRICANT_CONFIG;
  fields = GASOILANDLUBRICANT_FIELDS;

  protected prepareUpdateDto(data: any, selected: GasOilAndLubricantDto): GasOilAndLubricantUpdateDto {
    return {
      gasOilAndLubricantTypeId: data.gasOilAndLubricantTypeId,
      gasOilProviderId: data.gasOilProviderId,
      consumableId: data.consumableId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'GasOilAndLubricant';
  }
}
